const Loader = () => {
  return (
    <div className="fixed top-0 left-0 z-50 w-full h-full flex-center-center bg-main-bg dark:bg-main-dark">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
